<template>
  <l-layout :layout="['xs12']" bottom-space>
    <v-layout justify-center>
      <v-flex xs12>
        <v-card>
          <l-data-table
            ref="configList"
            :headers="(ownerType==='group')?group_header:person_header"
            hide-title-search
            :title-text="(ownerType==='group')?'分组配置列表':'个人配置列表'"
            :get-data-func="getConfigList"
            @click:row="goDetails('readonly',$event.item)"
            clickable
            selectable
            :filter-items="filterItems">
            <template slot="row-action" slot-scope="{item}">
              <td @click.stop>
              <v-btn icon @click="deleteConfig(item)">
                <v-icon>$vuetify.icons.delete</v-icon>
              </v-btn>
              </td>
            </template>
            <template slot="filter:ownerName">
              <v-flex xs4>
              <v-autocomplete
                v-if="ownerType==='group'"
                :items="filter.searchSelect"
                v-model="filterItems[0].value"
                v-on:keyup="getGroups"
                label="分组名称"
                clearable
                hide-details
                hide-selected
                item-text="name"
                item-value="id"
                prepend-icon="$vuetify.icons.group"
              >
                <template slot="no-data">
                  <v-alert :value="true" color="error">
                    暂无该分组信息
                  </v-alert>
                </template>
                <template slot="item" slot-scope="props">
                  <v-list-tile-content>
                    <v-list-tile-title>
                      <v-flex row align-center justify-between>
                        <span>{{props.item.name}}</span>
                      </v-flex>
                    </v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <span class="grey--text caption text-xs-right">{{props.item.loginId}}</span>
                  </v-list-tile-action>
                </template>
              </v-autocomplete>
              <v-autocomplete
                v-else
                :items="filter.searchSelect"
                v-model="filterItems[0].value"
                v-on:keyup="getUsers"
                label="用户姓名"
                clearable
                hide-details
                hide-selected
                :init-data="false"
                item-text="name"
                item-value="id"
                prepend-icon="$vuetify.icons.person"
              >
                <template slot="no-data">
                  <v-alert :value="true" color="error">
                    暂无该用户信息
                  </v-alert>
                </template>
                <template slot="item" slot-scope="props">
                  <v-list-tile-content>
                    <v-list-tile-title>
                      <v-flex row align-center justify-between>
                        <span>{{props.item.name}}</span>
                      </v-flex>
                    </v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <span class="grey--text caption text-xs-right">{{props.item.loginId}}</span>
                  </v-list-tile-action>
                </template>
              </v-autocomplete>
              </v-flex>
            </template>
          </l-data-table>
          <l-fixed-btn
            @click="addConfig"
            icon="$vuetify.icons.add"
          ></l-fixed-btn>
        </v-card>
      </v-flex>
    </v-layout>
  </l-layout>
</template>
<script>
import LDataTable from '../../ladmin/components/LDataTable/LDataTable'
import {time} from '../../ladmin/utils/time'
import LLayout from "../../ladmin/components/LLayout/LLayout";
export default{
  name: 'configList',
  components: {LLayout, LDataTable},
  props: {
    ownerType: {
      type: String,
      default: 'group'
    }
  },
  data () {
    return {
      selected: [],
      person_header: [
        {text: '用户名称', value: 'name', align: 'left', sortable: false},
        {text: '用户账号', value: 'loginId', align: 'left', sortable: false},
        {text: '最大可登记数', value: 'maxAllowed', align: 'left', sortable: true},
        {text: '创建时间', value: 'creationTime', placeholder: 'N/A', f: (v) => time.stringify(v)},
        {text: '', value: ''}
      ],
      group_header: [
        {text: '分组名称', value: 'name', align: 'left', sortable: false},
        {text: '最大可登记数', value: 'maxAllowed', align: 'left', sortable: true},
        {text: '创建时间', value: 'creationTime', placeholder: 'N/A', f: (v) => time.stringify(v)},
        {text: '', value: ''}
      ],
      filter:{
        searchSelect:[]
      },
      filterItems:[
        {
          key:'ownerName',
          value:''
        }
      ]
    }
  },
  methods: {
    async getConfigList ({pagination, sortStack, filterItems = [], search}) {
      let searchParam = {
        'searchParam': {
          'ownerType': {
            'order': 'ASC',
            'operators': [
              {
                'keyword': this.ownerType,
                'operator': 'EQ',
                'matchType': 'NONE'
              }
            ],
            'index': 1
          },
          'ownerId': {
            'order': 'ASC',
            'operators': [
              {
                'keyword': (filterItems[0] && filterItems[0].value) || '',
                'operator': 'LIKE',
                'matchType': 'BOTH'
              }
            ],
            'index': 1
          }
        }
      }
      let res = await this.$store.dispatch('vehicleRegister/getConfigList', {searchParam: searchParam, pagination: pagination})
      //console.log(res)
      if (res.data.status === 1) {
        let items = []
        let content = res.data.data.content || []
        
        for (let i = 0; i < content.length; i++) {
          let item = content[i]
          if (!item) continue
          
          let userName = ''
          let userLoginId = ''
          
          if (this.ownerType === 'group') {
            userName = (item.group && item.group.name) || ''
            userLoginId = ''
          } else {
            userName = (item.user && item.user.name) || ''
            userLoginId = (item.user && item.user.loginId) || ''
          }
          
          var obj = {
            creationTime: (item.config && item.config.creationTime) || null,
            maxAllowed: (item.config && item.config.maxAllowed) || 0,
            name: userName,
            loginId: userLoginId,
            item: item
          }
          items.push(obj)
        }
        
        let totalAmount = res.data.data.totalElements || content.length || 0
        return {items: items, amount: totalAmount}
      }
      else {
        this.$L.alert('error', {message: '查询失败，原因：' + res.data.msg})
        return {items: [], amount: 0}
      }
    },
    addConfig () {
      this.$router.push({
        name: 'newCommonConfig',
        query: {
          ownerId: '',
          status: 'new',
          ownerType: this.ownerType,
        }
      })
    },
    goDetails (status, item) {
      //console.log(item)
      let selectionString = document.getSelection().toString()
      if (!selectionString) {
        this.$router.push({
          name: 'commonConfig',
          query: {
            ownerId: (this.ownerType === 'group') ? item.item.group.id : item.item.user.id,
            status: status,
            ownerType: this.ownerType,
          }
        })
      }
    },
    async deleteConfig (item) {
      let ids = []
      if (item instanceof Object) {
        ids.push(item.item.config.id)
      }
      let {res, close} = await this.$L.confirm({title: '提示', text: '您确定要删除该配置？'})
      if (res) {
        try {
          let res = await this.$store.dispatch('vehicleRegister/deleteConfig', ids)
          if (res.data.status + '' === '1') {
            this.$L.alert('success', {message: '删除成功'})
            this.$refs.configList.refresh()
          }
          else {
            this.$L.alert('error', {message: '删除失败，原因：' + res.data.msg})
          }
        }
        catch (e) {
          this.$L.alert('error', e.message)
        }
      }
      close()
    },
    async getUsers (param) {
      let search = (param === undefined) ? '' : param.target.value
      let pagination = {page: 0, rowsPerPage: 100}
      let searchParam = {
        'searchParam': {
          'name': {
            'index': '1',
            'order': 'DESC',
            'operators': [
              {
                'keyword': search,
                'operator': 'LIKE',
                'matchType': 'BOTH'
              }
            ]
          }
        }
      }
      let res = await this.$store.dispatch('reservationConfig/getUsers', {param: searchParam, pagination: pagination})
      if (res.data.status === 1) {
        this.filter.searchSelect = res.data.data.content
      }
      else {
        this.filter.searchSelect = []
      }
    },
    async getGroups (param) {
      let search = (param === undefined) ? '' : param.target.value
      let pagination = {page: 0, rowsPerPage: 10}
      let searchParam = {
        'searchParam': {
          'name': {
            'index': '1',
            'order': 'DESC',
            'operators': [
              {
                'keyword': search,
                'operator': 'LIKE',
                'matchType': 'BOTH'
              }
            ]
          }
        }
      }
      let res = await this.$store.dispatch('reservationConfig/getGroups', {param: searchParam, pagination: pagination})
      if (res.data.status === 1) {
        this.filter.searchSelect = res.data.data.content
      }
      else {
        this.filter.searchSelect = []
      }
    },
  }
}
</script>
